// src/components/StepHeader.jsx
import React from 'react';

const StepHeader = ({ currentStep, handleStepChange }) => {
    return (
        <div className="relative flex justify-center items-center w-full my-6">
            {/* Barre de progression */}
            <div className="absolute top-1/2 w-10/12 h-1 bg-gray-300 transform translate-y-[-50%]">
                <div
                    className="h-1 bg-blue-500 transition-all duration-500"
                    style={{
                        width: `${(currentStep - 1) / 2 * 100}%`
                    }}
                ></div>
            </div>

            {['Informations Souscripteur', 'Personnes Affectées', 'Informations Contractuelles'].map((label, index) => (
                <React.Fragment key={index}>
                    {/* Cercle de l'étape */}
                    <div
                        // onClick={() => handleStepChange(index + 1)}
                        className={`relative z-10 flex items-center justify-center w-12 h-12 rounded-full cursor-pointer font-bold transition-colors duration-300 ${currentStep >= index + 1
                                ? 'bg-blue-500 text-white'
                                : 'bg-gray-300 text-gray-700 hover:bg-gray-400 hover:text-gray-800'
                            }`}
                    >
                        {index + 1}
                    </div>

                    {/* Lignes entre les étapes */}
                    {index < 2 && (
                        <div className="flex-1 h-1"></div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default StepHeader;
